import { Component, Input, OnChanges } from 'angular-ts-decorators';

import { IPrice, ISFCCProductPrice } from '@gn-audio/core/api/pricing/models';
import { getAvailabilityState } from '@gn-audio/core/api/pricing/utilities';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { AvailabilityState } from '@gn-audio/core/common/enums';

import { IHeroCustomizerAccessory, IHeroCustomizerGiftWrapping } from '../models';

import template from './hero-customizer-v3-totals.component.html';
import { IUrlParamKeyValuePair } from '@gn-audio/core';
import { accessoryTempCodeName } from '../constants/accessory-temp-code-name';

@Component({
  selector: 'heroCustomizerV3Totals',
  template,
})
export class HeroCustomizerV3TotalsComponent implements OnChanges {
  @Input() public group?: IProductWithAttributes;
  @Input() public accessories?: IHeroCustomizerAccessory[];
  @Input() public services?: IHeroCustomizerGiftWrapping[];

  public selectedItems: (IProductWithAttributes | IHeroCustomizerAccessory | IHeroCustomizerGiftWrapping)[];
  public accessoriesPrices?: (IPrice | ISFCCProductPrice)[] | null;
  public servicesPrices?: (IPrice | ISFCCProductPrice)[] | null;

  private groupAvailabilityState: AvailabilityState;

  private tempCodeArray: IUrlParamKeyValuePair[] = [
    {
      key: 'tempCode',
      value: accessoryTempCodeName
    }
  ];

  public ngOnChanges() {
    this.selectedItems = this.group && (this.areServicesSelected || this.areAccessoriesSelected) ? [this.group] : [];

    if (this.areAccessoriesSelected) {
      this.selectedItems.push(...this.accessories);
    }

    if (this.areServicesSelected) {
      this.selectedItems.push(...this.services);
    }
    
    this.accessoriesPrices = this.accessories?.map((accessory) => accessory.price);
    this.servicesPrices = this.services?.map((service) => service.price);
  }

  public get getQueryParameters() {
    return this.areAccessoriesSelected ? this.tempCodeArray : null;
  }

  public get areAccessoriesSelected(): boolean {
    return !!this.accessories?.length;
  }

  public get areServicesSelected(): boolean {
    return !!this.services?.length;
  }

  public onPriceLoaded(price?: IPrice | ISFCCProductPrice | null) {
    this.groupAvailabilityState = getAvailabilityState(price);
  }

  public get canProductBeBought(): boolean {
    return this.groupAvailabilityState <= AvailabilityState.BackOrder;
  }
}
